import ApiService from './api';

export default class ServerService extends ApiService {
  getVersion() {
    return this
      .fetchResource('/server/version', {
        responseType: 'text',
      });
  }

  getLinks() {
    return this.fetchResource('/server/links');
  }
}
